import React from 'react'
import { useSelector } from 'react-redux'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

import { getIncludedItemsCount } from '../../../helpers'

const Colour = () => {
  const {
    criteria: {
      colourLevelFilters: { includeOrExclude, selectedItems }
    },
    data: {
      colours: { items: allColours }
    }
  } = useSelector(state => state)

  const count = getIncludedItemsCount(
    includeOrExclude,
    allColours.length,
    selectedItems.length
  )

  return (
    <ListItem dense disableGutters>
      <ListItemText>Colours:</ListItemText>
      <ListItemSecondaryAction>
        {`${count.toLocaleString()} / ${allColours.length} included`}
      </ListItemSecondaryAction>
    </ListItem>
  )
}

export default Colour
